import {DEFAULT_HEADER_COLOR, ITEM_ORIGIN} from '../constants/constant';

export default {
  errors: {
    server: false,
    fulfillment: false,
    item: false,
    payment: false
  },
  restaurantCode: null,
  template: {
    name: 'dark',
    headerColour: DEFAULT_HEADER_COLOR,
    navigationMenu: null
  },
  language: 'en',
  order: {},
  checkoutData: {},
  loading: {
    sideBasket: false
  },
  basket: {
    uuid: null,
    items: [],
    deletedBasket: false
  },
  basketItem: {
    price: 0,
    mealUuid: null,
    quantity: 1,
    size: null,
    uuid: null,
    comments: '',
    selectedOptions: [],
    origin: ITEM_ORIGIN.MENU
  },
  tableBooking: {
    config: null,
    times: null,
    reservation: null
  },
  orderSource: null,
  serverOffline: false,
  upSelling: {
    modalCancelled: false
  }
};



// WEBPACK FOOTER //
// ./reducers/initial.state.js